import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Vip-Had",
  "use": "icon-Vip-Had-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Vip-Had\">\r\n<g id=\"icon-Vip-Had_Frame 633173\">\r\n<circle id=\"icon-Vip-Had_Ellipse 157\" cx=\"8.3125\" cy=\"8.90625\" r=\"7\" fill=\"#FF9603\" stroke=\"#F9F9F9\" stroke-width=\"2\" />\r\n<path id=\"icon-Vip-Had_Vector 116\" d=\"M5.30273 7.00781L8.3301 12.0343L11.3225 7.00818\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol